import { Box, Typography } from "@mui/material";
import React from "react";

import Highlight from "../../../../../Highlight";
import TruncatedText from "../../truncated-text";

const SIDEBAR_WIDTH = 208;
const BORDER_COLOR = "rgba(0,0,0,0.12)";

export const WorkerColumn = (
  {reassignment, searchedTerm}: any) => {
  const {
    workerFirstName,
    workerLastName,
    workerTypeName,
    workerSubTypeName,
    badgeNumber,
    companyEmployeeId,
  } = reassignment;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: 1,
        minWidth: SIDEBAR_WIDTH,
        maxWidth: SIDEBAR_WIDTH,
        borderRight: `1px solid ${BORDER_COLOR}`,
        padding: "8px 8px 8px 8px"
      }}
    >
      <Box
        sx={{
          width: "32px",
          minWidth: "32px",
          minHeight: "32px",
          height: "32px",
          borderRadius: "50%",
          backgroundColor: "#E0E0E0",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography sx={{
          fontSize: "14px",
          fontFamily: "Roboto",
          color: "rgba(0,0,0,0.87)",
        }}><Highlight value={`${workerFirstName?.[0]}${workerLastName?.[0]}`} searchText={searchedTerm} /></Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          maxWidth: "calc(100% - 48px)" }}
      >
        <TruncatedText text={`${workerFirstName} ${workerLastName}`}
                       tooltipDisabled={false}
                       style={{
                          fontSize: "14px",
                          fontFamily: "Roboto",
                          fontWeight: 500,
                          color: "rgba(0,0,0,0.87)",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "100%"
                        }}
                       searchedTerm={searchedTerm}
        />
        <TruncatedText text={reassignment.from.jobName} tooltipDisabled={false} style={{
          fontFamily: "Roboto",
          fontSize: "13px",
          color: "rgba(0,0,0,0.87)",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "100%"
        }} searchedTerm={searchedTerm} />
        <TruncatedText text={`${workerTypeName} (${workerSubTypeName})`} tooltipDisabled={false} style={{
          fontFamily: "Roboto",
          fontSize: "12px",
          color: "rgba(0,0,0,0.6)",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "100%"
        }} searchedTerm={searchedTerm} />
        {(badgeNumber || companyEmployeeId) && (
          <TruncatedText text={badgeNumber || companyEmployeeId} tooltipDisabled={false} style={{
            fontFamily: "Roboto",
            fontSize: "12px",
            color: "rgba(0,0,0,0.6)",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "100%"
          }} searchedTerm={searchedTerm} />
        )}
      </Box>
    </Box>
  );
}